import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useEffect } from "react";

import { IRealizationCreateParams } from "../../../state";
import {
  Context,
  fetchCareerFeedbackQuestions,
  createRealization,
  CREATE_REALIZATION_FROM_CAREER_QUESTION_SUCCESS_MESSAGE,
  CREATE_REALIZATION_FROM_CAREER_QUESTION_FAILURE_MESSAGE,
} from "../../../store/student";
import useToast from "../../../hooks/useToast";
import Toast from "../../../molecules/Toast";
import LoginHeader from "../../../organisms/LoginHeader";
import CareerQuestion from "../../../templates/CareerQuestion";
import styles from "../common.module.scss";

const CareerQuestionPage = () => {
  const { contextState, dispatch } = useContext(Context);
  const { toast, setToast, handleToast } = useToast();

  useIonViewWillEnter(() => {
    dispatch(fetchCareerFeedbackQuestions());
  });

  useEffect(() => {
    const successMessages = [
      CREATE_REALIZATION_FROM_CAREER_QUESTION_SUCCESS_MESSAGE,
    ];
    const errorMessages = [
      CREATE_REALIZATION_FROM_CAREER_QUESTION_FAILURE_MESSAGE,
    ];

    handleToast("success", contextState.success_message, successMessages);
    handleToast("danger", contextState.error, errorMessages);
  }, [contextState.success_message, contextState.error, handleToast]);

  const createRealizationFunc = (questionId: number, answer: string) => {
    const params: IRealizationCreateParams = {
      category_ids: [],
      submitted: false,
      shared: false,
      kind: "roots",
      content: answer,
      careergear_feedback_question_id: questionId,
    };

    dispatch(createRealization(params, [], [], null));
  };

  return (
    <IonPage>
      <Toast
        type={toast.type}
        showToast={toast.isShow}
        onClose={() => setToast({ ...toast, isShow: false })}
        message={toast.message}
      />
      <LoginHeader title="ストック" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <CareerQuestion createRealization={createRealizationFunc} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerQuestionPage;
